import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/ProductListTitle/ProductListTitle.js
const ProductListTitle = createSectionForm({
  icon: "heading",
  title: "Product List Title",
  fields: [
    { name: "title", label: "Title", placeholder: "Products" },
    {
      name: "description",
      label: "Description",
      type: "textarea",
      help: "Used on /products. Category, brand and catalog pages show their own name and details.",
    },
  ],
});

export default ProductListTitle;
